<template>
  <div class="animated fadeIn list-of-ap">
    <b-card>
      <div slot="header">Realisasi Invoice Unearned Income 
        <div class="card-header-actions">
          <b-dropdown text="Import/Upload" variant="primary mr-1" >
            <b-dropdown-item @click="showUploadFrm=true" >Start Upload</b-dropdown-item>
            <b-dropdown-item @click="showUploadedCancelFrm=true" >Cancel Uploaded</b-dropdown-item>
          </b-dropdown>
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-dropdown text="Posting" variant="primary mr-1" >
            <b-dropdown-item @click="posting" :disabled="(model.posting == 1)">Posting</b-dropdown-item>
            <b-dropdown-item @click="posting" :disabled="(model.posting != 1)">Un Posting</b-dropdown-item>
            <b-dropdown-item @click="postAll_Confirm=true" >Post/UnPost All</b-dropdown-item>
          </b-dropdown>
          <!-- <b-button variant="primary mr-1" @click="posting()"><i class="fa fa-paper-plane"></i> Posting</b-button> -->
          <b-button variant="primary mr-1" @click="printjv()"><i class="fa fa-print"></i> Print Jv</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
            <b-row>
              <b-col lg="8">
                  <b-input-group >
                    <b-input-group-prepend><label>Invoice Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="4">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Source &nbsp;</span></b-input-group-prepend>
                      <b-form-select v-model="tblData.invmanual" :plain="true" :options="invSources"></b-form-select>
                    </b-input-group>
                </b-col>
            </b-row>            
              <b-row>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Invoice Number</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.nomor" placeholder="AR Invoice Number"></b-form-input>
                    </b-input-group>
                  </b-col>
                <b-col  lg="6">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Outstanding &nbsp;</span></b-input-group-prepend>
                      <b-form-select v-model="tblData.outstand" :plain="true" :options="dataList.YesNoAll"></b-form-select>
                      <b-form-select v-model="tblData.ostStatuskey" :plain="true" :options="dataList.ostandStatus"></b-form-select>
                    </b-input-group>
                </b-col>
              </b-row>                      

            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
              </b-input-group>
        </b-col>
        <b-col lg="6">
              <b-row>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.customer" placeholder="Customer"></b-form-input>
                    </b-input-group>
                  </b-col>
                <b-col  lg="6">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Order Number &nbsp;</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.po" placeholder="Purch. Order#"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>            
            <b-input-group >
                <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                <b-form-input v-model="tblData.uraian" ></b-form-input>
            </b-input-group>
              <b-row no-gutters>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Posting Group</label></b-input-group-prepend>
                      <b-form-select v-model="tblData.postgroup" :plain="true" :options="postGroups"></b-form-select>
                    </b-input-group>
                  </b-col>
                <b-col  lg="2">
                      <b-form-select v-model="tblData.posting" :plain="true" :options="dataList.postingStatus"></b-form-select>
                </b-col>
                <b-col lg="4" >
                    <b-button class="btn btn-success ml-3" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button class="btn btn-secondary" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
                </b-col>
              </b-row>                      
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
        <template v-slot:cell(invdate)="data">
          {{ data.item.invdate | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(ttlamtdue)="data">
          <div v-if="data.item.posting==0" style="background-color:yellow;">           
            {{(data.item.ttlamtdue)|numFormat}}
          </div>
          <div v-else> 
            {{(data.item.ttlamtdue)|numFormat}}
          </div>
        </template>

        <template v-slot:cell(outstand)="data">
          {{data.item.outstand | numFormat}}
        </template>
      </b-table>
      <b-row >
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2" >
            <b-input-group >
                <b-input-group-prepend><span  class="pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <b-modal v-model="showPostingConfirm" title="Posting Record?" :centered="true" @ok="postingData">
        <p class="mb-1">The selected a row of data will be Posted to Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">You can unpost as long as <strong>Accounting Periode</strong> stil open</p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Un Posting Record?" :centered="true" @ok="unpostData">
        <p class="mb-1">The selected a row of data will be UnPosted from Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">Data Journal will be removed from <strong>Accounting</strong></p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" hide-footer>
        <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
        <b-row class="justify-content-center mt-1">
            <b-button variant="primary" v-if="(isprintjv==true)" @click.stop="editjv">Edit Journal</b-button>
            <b-button variant="secondary" class="ml-2" @click="showReport=false" > Close</b-button>
        </b-row>
    </b-modal>

    <b-modal v-model="showUploadFrm" header-bg-variant="primary" size="lg" title="Import/Upload REALISASI INVOICE PROFORMA" :centered="true" @ok="handleOk" ok-title="Process">
        <b-form @submit.stop.prevent="uploadinv">
            <b-row>
              <b-col lg="6">
                <b-input-group>
                    <b-input-group-prepend ><label >AR Type/Group </label></b-input-group-prepend>
                    <b-form-select v-model="frmdata.artype" :plain="true" :options="arWithSale" :state="!$v.frmdata.artype.$error"></b-form-select>                              
                </b-input-group>

              </b-col>
              <b-col lg="6">
                <b-input-group >
                    <b-input-group-prepend><label> &nbsp;</label></b-input-group-prepend>
                    <b-input-group-prepend>
                            <b-link @click="downloadtemplate"><i class="fa fa-paperclip"></i> EkosSystem-AR-upload-template.xlsx</b-link>
                    </b-input-group-prepend>
                </b-input-group>            
              </b-col>
            </b-row>
            <b-input-group >
                <b-input-group-prepend><label >Choose *.XLSX file</label></b-input-group-prepend>
                <b-form-file
                  v-model="fileXlsx"
                  :state="Boolean(fileXlsx)"
                  placeholder="Choose a XLSX file..."
                  drop-placeholder="Drop XLSX file here..."
                ></b-form-file>
            </b-input-group>
            <b-row no-gutters>
              <b-col lg="6">
                <b-input-group>
                    <b-input-group-prepend ><span class="p-2">Excel Worksheet Name </span></b-input-group-prepend>
                    <b-form-input v-model="frmdata.sheetName" :state="!$v.frmdata.sheetName.$error"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col lg="3">
                <b-input-group>
                    <b-input-group-append ><label class="input-group-text">Data staring from Row </label></b-input-group-append>
                    <b-form-input v-model="frmdata.startRow"  type="number" :state="!$v.frmdata.startRow.$error"></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
            <b-card class="ColsDefine">
                  <strong>mendefiniskan kolom di-Excel untuk setiap atribut/info INVOICE REALISASI DEFFERED/UNEARNED</strong>
              <b-row>
                <b-col lg="3">
                    <b-input-group>
                        <b-input-group-prepend ><label>Invoice Number</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.invoiceno" :plain="true" :options="kolomXls" :state="!$v.frmdata.invoiceno.$error"></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Invoice Date</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.invdate" :plain="true" :options="kolomXls" :state="!$v.frmdata.invdate.$error"></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Customer Code</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.CustCode" :plain="true" :options="kolomXls" :state="!$v.frmdata.CustCode.$error"></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Customer Name</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.CustName" :plain="true" :options="kolomXls" :state="!$v.frmdata.CustName.$error"></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Description #1</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.uraian1" :plain="true" :options="kolomXls" :state="!$v.frmdata.uraian1.$error"></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Description #2</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.uraian2" :plain="true" :options="kolomXls" ></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Order Number</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.ordernumber" :plain="true" :options="kolomXls" ></b-form-select>                              
                    </b-input-group>
                </b-col>
                <b-col lg="3">
                    <b-input-group>
                        <b-input-group-prepend ><label>Gross Value</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.ttlgross" :plain="true" :options="kolomXls" :state="!$v.frmdata.ttlgross.$error"></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Discount Value</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.ttldiskon" :plain="true" :options="kolomXls" ></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Netto Value</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.ttlnetto" :plain="true" :options="kolomXls" :state="!$v.frmdata.ttlnetto.$error"></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>VAT Value</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.ttlvat" :plain="true" :options="kolomXls" :state="!$v.frmdata.ttlvat.$error"></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Total Due Value </label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.ttlamtdue" :plain="true" :options="kolomXls" :state="!$v.frmdata.ttlamtdue.$error"></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Currency</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.matauang" :plain="true" :options="kolomXls" ></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Exch.Rate</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.kursPPN" :plain="true" :options="kolomXls" ></b-form-select>                              
                    </b-input-group>
                </b-col>
                <b-col lg="3">
                    <b-input-group>
                        <b-input-group-prepend ><label>N P W P</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.npwp" :plain="true" :options="kolomXls" ></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Nama WP</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.npwp_name" :plain="true" :options="kolomXls" ></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>No. Faktur Pajak</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.nofaktur" :plain="true" :options="kolomXls" ></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Tgl. Faktur Pajak</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.tglfaktur" :plain="true" :options="kolomXls" ></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Sales AE</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.accexec" :plain="true" :options="kolomXls" ></b-form-select>                              
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend ><label>Related To Invoice#</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.invoicereff" :plain="true" :options="kolomXls" :state="!$v.frmdata.invoicereff.$error"></b-form-select>                              
                    </b-input-group>
                    <div style="font-size:smaller;display:block;text-align:right;"> Manual Deffered/UnEarned Inv.</div>
                </b-col>
                <b-col lg="3">
                    <b-input-group>
                        <b-input-group-prepend ><label>Cashflow Code</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.kodecash" :plain="true" :options="kolomXls" ></b-form-select>                              
                    </b-input-group>
                    <b-input-group v-for="dim in dimension" :key="dim.value">
                      <b-input-group-prepend><label>{{dim.text}} Code</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata[`${dim.value}`]" :plain="true" :options="kolomXls" ></b-form-select>                              
                    </b-input-group>
                    <b-input-group class="mt-5">
                        <b-input-group-prepend ><label>Bentuk Bayar</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.pack_name" :plain="true" :options="kolomXls" ></b-form-select>                              
                    </b-input-group>

                </b-col>

              </b-row>
            </b-card>
        </b-form>
    </b-modal>
    <b-modal v-model="showUploadedCancelFrm" header-bg-variant="danger" title="Cancel Uploaded AR INVOICE" :centered="true"  hide-footer>
              <b-input-group >
                  <b-input-group-prepend><label style="width:100px !important;">Upload Date</label></b-input-group-prepend>
                  <b-form-input v-model="postAllfrm.invdate" type="date" :state="!$v.postAllfrm.invdate.$error"></b-form-input>
              </b-input-group>
              <b-input-group>
                  <b-input-group-prepend ><label style="width:100px !important;">AR Type/Group</label></b-input-group-prepend>
                  <b-form-select v-model="postAllfrm.artype" :plain="true" :options="artypes" :state="!$v.postAllfrm.artype.$error"></b-form-select>                              
              </b-input-group>
            <div style="text-align:right; display:blocked" class="mt-3" >
                <b-button variant="danger" class="ml-1" @click="unuploadinv" > <i class="fa fa-undo"></i> Process</b-button>
                <b-button variant="secondary" class="ml-1" @click="showUploadedCancelFrm=false" > <i class="fa fa-close"></i> Close</b-button>
            </div>
    </b-modal>

    <b-modal v-model="postAll_Confirm" title="Posting/UnPosting multiple records" :centered="true"  hide-footer>
              <b-input-group >
                  <b-input-group-prepend><label style="width:100px !important;">Periode</label></b-input-group-prepend>
                  <vue-monthly-picker style="width:333px;" v-model="postAllfrm.invdate" :state="!$v.postAllfrm.invdate.$error" dateFormat="MMMM YYYY" :monthLabels="monthLabels"></vue-monthly-picker>
              </b-input-group>
              <b-input-group>
                  <b-input-group-prepend ><label style="width:100px !important;">AR Type/Group</label></b-input-group-prepend>
                  <b-form-select v-model="postAllfrm.artype" :plain="true" :options="artypes" :state="!$v.postAllfrm.artype.$error"></b-form-select>                              
              </b-input-group>
            <div style="text-align:right; display:blocked" class="mt-3" >
                <b-button variant="success" @click="postAll"><i class="fa fa-paper-plane"></i> Posting All</b-button>
                <b-button variant="danger" class="ml-1" @click="unpostAll" > <i class="fa fa-undo"></i> Un Posting All</b-button>
                <b-button variant="secondary" class="ml-1" @click="postAll_Confirm=false" > <i class="fa fa-close"></i> Close</b-button>
            </div>
    </b-modal>

  </div>
</template>

<style lang="scss">
    .ColsDefine {
      .input-group {
          .input-group-prepend {
              label {
                  width: 135px !important;
              }
          }
      }
    }

</style>


<script>
import VueMonthlyPicker from 'vue-monthly-picker';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import crud from "../../apis/crud";
import arinv from "../../apis/arinvrealisasi";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { VueMonthlyPicker,Loading},
  mixins: [validationMixin],
  validations: {
        frmdata: {
            sheetName: { required },
            startRow: { required },
            CustCode: { required },
            CustName: { required },
            uraian1: { required },
            invoiceno: { required },
            invoicereff : { required },
            invdate: { required },
            artype: { required },
            // matauang: { required },
            ttlgross: { required },
            ttlnetto: { required },
            ttlvat: { required },
            ttlamtdue: { required },
        },
        postAllfrm: {
          artype: { required },
          invdate: { required }
        }
  }, 
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      postAll_Confirm: false,
      postAllfrm:{artype:'', invdate: this.$store.state.user.tglaktif},
      monthLabels:dropdown.monthLabels,
      showUploadFrm: false,
      showUploadedCancelFrm: false,
      fileXlsx: null,
      frmdata:{sheetName:'AR_LIST', startRow:8, invoiceno:'A', invdate:'B', CustCode:'C',CustName:'D', uraian1:'E', uraian2:'', 
            matauang:'',ttlgross:'H',ttldiskon:'',ttlnetto:'J',ttlvat:'K',ttlamtdue:'L', invoicereff:''},
      kolomXls:['','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z',
      'AA','AB','AC','AD','AE','AF','AG','AH','AI','AJ','AK','AL','AM','AN','AO','AP','AQ','AR','AS','AT','AU','AV','AW','AX','AY','AZ'],
      isLoading:false,
      isprintjv:false,
      showReport:false,
      reportUrl: null,
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'invdate',
        sortDesc: true,
        DimCol:'Dim1'
      },
      pagination:false,
      items:[],
      model:{},
      artypes:[],
      arWithSale:[],
      invSources:[{ value: '', text: '--- ALL ---'},{ value: '0', text: 'Upload/Import'},{ value: '1', text: 'Manual Entry'}],
      postGroups:[{ value: '', text: '--- ALL ---'}],
      dataList: {
        YesNoAll: dropdown.ostandStatus,
        postingStatus: dropdown.postingStatus,
        ostandStatus:[{value:'',text:''}],
      }      
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
          {
            key: "invoiceno0",
            thStyle: "width:150px",
            label: "Inv.# Unearned",
            sortable: true
          },
          {
            key: "invoiceno",
            thStyle: "width:100px",
            label: "Inv.# Realisasi",
            sortable: true
          },
          {
            key: "invdate",
            thStyle: "width:90px",
            label: "Inv. Date",
            sortable: true
          },
          {
            key: "custinfo",
            label: "Customer",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "uraian",
            thStyle: "width:400px",
            label: "Description",
            sortable: true
          },
          {
            key: "ordernumber",
            thStyle: "width:150px",
            label: "PO/SO #",
            sortable: true
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "ttlamtdue",
            label: "Invoice Amount",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "outstand",
            label: "Outstanding",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "invoicereff",
            thStyle: "width:150px",
            label: "Related to Other Inv.#",
            sortable: true
          },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: `${dims[i].value}Txt`,
            thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    },
    invalidModel() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
    invalidPostAll() {
      this.$v.postAllfrm.$touch();
      return this.$v.postAllfrm.$invalid;
    },
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
  },
  created: function(){
        setTimeout(async () => {
            const [a,b, c] = await Promise.all([arinv.postgroup(),arinv.outstandstatus(),crud.list({tablename:'upload-arinv2'})]) ;
            this.artypes = a;
            // this.dataList.ostandStatus = b;
            this.dataList.ostandStatus = this.dataList.ostandStatus.concat(b);

            // this.artypes = await arinv.postgroup();
            this.postGroups = this.artypes.reduce((newArr,item) =>{
                if (item.saleCode)
                {
                  this.arWithSale.push(item);
                }
                  newArr.push(item);
                  return newArr;
              },[{ value: '', text: '--- ALL ---'}]);

          const [uploadConfig] = c;
          // console.log(uploadConfig);
            for (var key in uploadConfig) {
                if(uploadConfig[key]!="null" && uploadConfig[key]!=''){
                  this.frmdata[key] = uploadConfig[key];
                }
            }
          
        }, 1000);
        // const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        // this.tblData.tgl1= this.tblData.tgl1 || this.$store.state.user.tglaktif;
        // this.tblData.tgl2= this.tblData.tgl2 || tgl2.format('YYYY-MM-DD');
  },  
  methods: {
    downloadtemplate: function(){
      arinv.downloadtemplate();
    },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.arinv2list) {
            this.tblData[key] = filter.arinv2list[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.arinv2list.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.arinv2list;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await arinv.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await arinv.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
        }
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.customer= '';
        this.tblData.po=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.posting=  '';
        this.tblData.postgroup=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
        this.tblData.invmanual=  '';
        this.tblData.ostStatuskey=  '';
        this.$forceUpdate();
    },
    saveFilter() {
      const keys = ['uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'customer', 'po', 'postgroup', 'posting', 'invmanual', 'ostStatuskey'];
      let filtered = false;
      const arinv2list={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              arinv2list[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          arinv2list.page=this.tblData.page;
          arinv2list.limit=this.tblData.limit;
          arinv2list.sortBy=this.tblData.sortBy;
          arinv2list.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.arinv2list=arinv2list;
          this.$store.commit("filter", filter);
      }
    },       
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    handleOk: function(evt) {
        evt.preventDefault()
        if (this.invalidModel) {
            console.log('validation : ', this.$v.frmdata);
            console.log('frmdata obj : ',this.frmdata);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else if (this.fileXlsx) {
            this.showUploadFrm = false;
            // this.$forceUpdate();
            this.uploadinv()
        } else {
          toastr.warn('Please select one File XLSX that want to Upload ');
        }
    },
    uploadinv: async function() {
      // if (this.invalidModel) {
      //       console.log('validation : ', this.$v.frmdata);
      //       console.log('frmdata obj : ',this.frmdata);
      //       toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
      //   } else if (this.fileXlsx) {
      //       this.showUploadFrm = false;
            this.isLoading=true;
            try {
                const response = await arinv.upload(this.fileXlsx,this.frmdata);
                this.isLoading=false;   
                console.log(response); 
                const ada = this.artypes.find(t => t.value==this.frmdata.artype)
                if (ada) {
                    toastr.success(`${ada.text} , Complete sucessfully`,'UPLOAD/IMPORT INVOICE',10000);
                } else toastr.success(`Complete sucessfully`,'UPLOAD/IMPORT INVOICE',10000);

            } catch (error) {
                this.isLoading=false;
                this.showUploadFrm = true;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else {
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }
                }
            }
        // } else {
        //   toastr.warn('Please select one File XLSX that want to Upload ');
        // }
    },
    unuploadinv: async function(evt){
        evt.preventDefault()
        if (this.invalidPostAll) {
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
          try {
              this.showUploadedCancelFrm = false;
              this.isLoading=true;
              await arinv.unupload({invdate: moment(this.postAllfrm.invdate).format('YYYY-MM-DD'), artype: this.postAllfrm.artype});
              this.refresh();
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }        
          }
      }
    },     
    add(){
      this.saveFilter();
      router.push({name :"receivable.arinvrealisasifrm"});
    },
    edit: function() {
        if (this.model) {
          this.saveFilter();
          router.push({name :'receivable.arinvrealisasifrm', params: { arinvKey: this.model.arinvKey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await arinv.remove(this.model);
      this.refresh();
        // const index= this.items.findIndex(r => (r.arinvKey==this.model.arinvKey));
        // this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    rowClicked(record, index) {
      // if (this.model.arinvKey == record.arinvKey) {
      //     this.edit();
      // } else {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      // }
    },
    posting: async function () {
        if (this.model) {
            if ((this.model.posting || 0) == 0) {
                this.showPostingConfirm = true;
            }
            if (this.model.posting == 1) {
                this.showUnpostConfirm = true;
            }
        } else {
            toastr.warn('Please select a row that want to be Posted!');
        }
    }, 
    postingData: async function(){
        this.isLoading=true;
        try {
            await arinv.posting(this.model);
            this.model.posting=1;
            this.printjv();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    unpostData: async function(){
        this.isLoading=true;
        try {
            await arinv.postingUndo(this.model);
            this.model.posting=0;
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    postAll: async function(evt){
        evt.preventDefault()
        if (this.invalidPostAll) {
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
          try {
              this.postAll_Confirm = false;
              this.isLoading=true;
              await arinv.postall({invdate: moment(this.postAllfrm.invdate).format('YYYY-MM-DD'), artype: this.postAllfrm.artype});
              this.refresh();
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }        
          }
      }
    },  
    unpostAll: async function(evt){
        evt.preventDefault()
        if (this.invalidPostAll) {
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
          try {
              this.postAll_Confirm = false;
              this.isLoading=true;
              await arinv.unpostall({invdate: moment(this.postAllfrm.invdate).format('YYYY-MM-DD'), artype: this.postAllfrm.artype});
              this.refresh();
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }        
          }
      }
    },      
    editjv: function() {
        if (this.model) {
            this.saveFilter();
            const tanggal = moment(this.model.invdate).format('YYYY-MM-DD');
          router.push({name :'receivable.editjvfrm', params: { nomor: this.model.invoiceno, tanggal, kodejurnal:'ARINV'}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },    
    printjv: async function()
    {
      if (this.model) {
          this.isLoading=true;
          try {
              this.isprintjv=true;
                this.showReport=true;
              this.reportUrl= await arinv.printjv(this.model);
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await arinv.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },
    close(){
      router.push("/receivable/home");
    },    
  }
};
</script>
